import { colors } from "./colors";
import { stdObject } from "./types/stdObject";
import PaidIcon from "@mui/icons-material/Paid";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

export const headerAccessLog: Array<stdObject> = [
  { code: "USUIP0", label: "p.user", type: "users" },
  { code: "IPIP0", label: "p.globalIp", align: "center" },
  { code: "LOCIP0", label: "p.localIp", align: "center" },
  { code: "COUIP0", label: "p.country", align: "center", type: "countries" },
  { code: "DATIP0", label: "p.date", align: "center", type: "date" },
  {
    code: "OSIP0",
    label: "p.operatingSystem",
    align: "center",
  },
  { code: "DEVIP0", label: "p.device", align: "center", type: "devices" },
  { code: "MOBIP0", label: "p.mobile", align: "center", type: "checkbox" },
  { code: "ACTIP0", label: "p.access", align: "center", type: "checkbox" },
];

export const summaryHeader = [
  { code: "NAME", label: "p.description" },
  { code: "TOTAL", label: "p.total", align: "right" },
];

export const commHeaders = (extra: stdObject[]) => [
  { code: "FECCOYP", label: "p.date", type: "date" },
  { code: "NOMCOYP", label: "p.staff" },
  { code: "TOTCOYP", label: "p.total", align: "right" },
  ...extra,
  { code: "PAGCOYP", label: "p.paid", align: "right" },
];

export const headerOthersInterv: Array<stdObject> = [
  { code: "ART", label: "c.COD" },
  { code: "NOM", label: "c.DES" },
  { code: "CAN", label: "c.CAN", align: "center" },
  { code: "PRE", label: "d.PRE", align: "right", type: "price" },
  // { code: "DATE", label: "d.DES2" },
  { code: "TOT", label: "c.TOT", align: "right", type: "price" },
];

export const headerDocItems: Array<stdObject> = [
  {
    code: "LIN",
    label: "p.line",
    align: "center",
    style: { color: colors.black, width: 30 },
  },
  { code: "ART", label: "c.COD", style: { color: colors.black, width: 100 } },
  { code: "NOM", label: "c.DES", style: { color: colors.black } },
  {
    code: "CAN",
    label: "c.CAN",
    align: "center",
    style: { color: colors.black, width: 30 },
  },
  {
    code: "PRE",
    label: "d.PRE",
    align: "right",
    type: "price",
    style: { color: colors.black, width: 100 },
  },
  {
    code: "TOT",
    label: "c.TOT",
    align: "right",
    type: "price",
    style: { color: colors.black, width: 100 },
  },
];

export const headerCash: Array<stdObject> = [
  { code: "FECCAJ", label: "p.date", type: "date" },
  { code: "NOMCAJ", label: "p.description" },
  { code: "TOT", label: "d.PRE", align: "right", type: "price" },
];

export const headerCommItems: Array<stdObject> = [
  { code: "FECHA", label: "c.FEC", type: "date" },
  { code: "DOCCOY2", label: "c.DOC", align: "center" },
  { code: "CODCOY", label: "p.number" },
  { code: "LINCOY2", label: "p.line", align: "center" },
  { code: "CLICOY", label: "c.CLI", align: "left" },
  { code: "RNOCOY", label: "c.RNO", align: "left" },
  { code: "NOMCOY", label: "p.description", align: "left" },
  { code: "BASCOY", label: "p.base", align: "center" },
  { code: "CANCOY", label: "p.quantity", align: "center" },
  { code: "PRECOY", label: "p.price", align: "right", type: "price" },
  { code: "TOTCOY", label: "p.total", align: "right", type: "price" },
  {
    code: "PROCOY",
    label: "p.percentage",
    align: "center",
    type: "percentage",
  },
  { code: "COMMCOY", label: "p.commission", align: "right", type: "price" },
  {
    code: "COMMTOTCOY",
    label: "p.totalCommission",
    align: "right",
    type: "price",
  },
  { code: "EST2COY", label: "c.EST2", align: "center" },
  { code: "PAGCOY", label: "p.approved", align: "center" },
];

export const headerCommPay: Array<stdObject> = [
  { code: "FECCOYP", label: "c.FEC", type: "date", style: { width: 130 } },
  { code: "CODCOYP", label: "p.number", style: { width: 50 } },
  { code: "NOMCOYP", label: "p.name", style: { width: 170 } },
  {
    code: "TOTCOYP",
    label: "p.total",
    align: "right",
    type: "price",
    style: { width: 50 },
  },
  {
    code: "BUTTONCOYP",
    label: "p.payment",
    type: "icon",
    Icon: PaidIcon,
    align: "center",
    style: { width: 50 },
  },
  {
    code: "BUTTONDELCOYP",
    label: "p.delete",
    type: "icon",
    Icon: DeleteForeverIcon,
    align: "center",
    style: { width: 50 },
  },
];

export const headerUsers: Array<stdObject> = [
  { code: "ACCUSU", label: "c.ACC" },
  { code: "NOMUSU", label: "c.NOM" },
  { code: "ACTIVO", label: "p.active", align: "center", type: "checkbox" },
  { code: "SUC", label: "c.SUC", align: "center", type: "branches" },
  { code: "MULUSU", label: "c.MUL", align: "center", type: "checkbox" },
  { code: "BLOUSU", label: "c.BLO", align: "center", type: "checkbox" },
  { code: "WEBUSU", label: "c.WEB", align: "center", type: "checkbox" },
  { code: "DWNUSU", label: "c.DWN", align: "center", type: "checkbox" },
  { code: "LANG", label: "p.language", align: "center", type: "lang" },
  { code: "ROLUSU", label: "c.ROL", align: "center", type: "rol" },
  { code: "CODUSU", label: "", align: "center", type: "reset" },
];

export const headerWeb: Array<stdObject> = [
  { code: "ANCCAB", label: "c.ANC", align: "center", type: "integer" },
  { code: "ACTCAB", label: "c.ACT", align: "center", type: "checkbox" },
  { code: "EXICAB", label: "c.EXI", align: "center", type: "checkbox" },
  { code: "DOCCAB", label: "c.DOC", align: "center", type: "checkbox" },
  { code: "EDICAB", label: "c.EDI", align: "center", type: "checkbox" },
  { code: "BUSCAB", label: "c.BUS", align: "center", type: "checkbox" },
];

export const fieldsPersonItemTitles: stdObject[] = [
  // { code: "CODPER", label: "c.COD", align: "center" },
  { code: "FIEPER", label: "c.FIE", align: "center" },
  { code: "ACTPER", label: "c.ACT", align: "center", type: "checkbox" },
  { code: "EXIPER", label: "c.EXI", align: "center", type: "checkbox" },
  // { code: "BUSPER", label: "c.BUS", align: "center", type: "checkbox" },
  // { code: "DOCPER", label: "c.DOC", align: "center", type: "checkbox" },
  { code: "ORDPER", label: "p.order", align: "center" },
  // { code: "TABPER", label: "c.TAB", align: "center" },
];

export const headerTitles: stdObject[] = [
  { code: "CODCAB", label: "c.COD" },
  // { code: "GRUCAB", label: "c.ARE", align: "center", type: "checkbox" },
  // { code: "USUCAB", label: "c.user", align: "center", type: "checkbox" },
  { code: "ANCCAB", label: "c.ANC", align: "center", type: "integer" },
  { code: "ACTCAB", label: "c.ACT", align: "center", type: "checkbox" },
  { code: "EXICAB", label: "c.EXI", align: "center", type: "checkbox" },
  { code: "DOCCAB", label: "c.DOC", align: "center", type: "checkbox" },
  { code: "EDICAB", label: "c.EDI", align: "center", type: "checkbox" },
  { code: "BUSCAB", label: "c.BUS", align: "center", type: "checkbox" },
  { code: "MODCAB", label: "c.MOD", align: "center", type: "mode" },
  { code: "TITCAB", label: "c.TIT", align: "center", type: "checkbox" },
  { code: "BORCAB", label: "c.BOR", align: "center", type: "integer" },
  { code: "BDECAB", label: "c.BDE", align: "center", type: "checkbox" },
  { code: "ALICAB", label: "c.ALI", align: "center", type: "align" },
  { code: "NWRCAB", label: "c.NWR", align: "center", type: "checkbox" },
  { code: "ORDCAB", label: "p.order", align: "center", type: "integer" },
  { code: "ANECAB", label: "c.ANE", align: "center" },
  { code: "SIZCAB", label: "c.SIZ", align: "center", type: "integer" },
  { code: "BLOCAB", label: "c.BLO", align: "center", type: "checkbox" },
  { code: "HISCAB", label: "c.HIS", align: "center", type: "checkbox" },
  { code: "FICCAB", label: "c.FIC", align: "center", type: "checkbox" },
  { code: "POSCAB", label: "c.POS", align: "center", type: "checkbox" },
  { code: "MAPCAB", label: "c.MAP", align: "center", type: "checkbox" },
  { code: "VALCAB", label: "c.VAL", align: "center" },
];

export const headerLanguages: stdObject[] = [
  { code: "CODLAN", label: "c.COD" },
  { code: "EN", label: "l.en", align: "center" },
  { code: "ES", label: "l.es", align: "center" },
  { code: "HANT", label: "l.hant", align: "center" },
  { code: "HANS", label: "l.hans", align: "center" },
];

export const areasTitles: stdObject = {
  PAI: [
    { code: "ACTPAI", label: "c.ACT", align: "center", type: "checkbox" },
    { code: "BALPAI", label: "c.BAL" },
    // { code: "COD2PAI", label: "c.COD2" },
    { code: "CODPAI", label: "c.COD" },
    { code: "CONPAI", label: "c.CON" },
    { code: "DIGPAI", label: "c.DIG" },
    { code: "DIVPAI", label: "c.DIV" },
    { code: "DNOPAI", label: "c.DNO" },
    { code: "NOMPAI", label: "c.NOM" },
    { code: "SIGPAI", label: "c.SIG" },
    { code: "TELPAI", label: "c.TEL" },
    { code: "WEBPAI", label: "c.WEB" },
  ],
  BCK: [
    { code: "date", label: "c.FEC", align: "center", type: "date" },
    { code: "file", label: "c.NOM", align: "center" },
    { code: "size", label: "c.SIZ", align: "center" },
  ],
  SUC: [
    { code: "ACTSUC", label: "c.ACT", align: "center", type: "checkbox" },
    { code: "CODSUC", label: "c.COD", type: "info" },
    { code: "NBRSUC", label: "c.NBR" },
    { code: "NOMSUC", label: "c.NOM" },
    { code: "RSOSUC", label: "c.RSO" },
    { code: "RUCSUC", label: "c.RUC" },
    { code: "PAISUC", label: "c.PAI", align: "center", type: "countries" },
    { code: "ALMSUC", label: "c.ALM", align: "center", type: "branches" },
    { code: "VENTAS", label: "p.sales", align: "center", type: "checkbox" },
    { code: "IRESUC", label: "c.IRE", align: "center", type: "salesReport" },
    { code: "FISSUC", label: "c.FIS", align: "center", type: "checkbox" },
    { code: "TALSUC", label: "c.TAL", align: "center", type: "checkbox" },
    { code: "DIRSUC", label: "c.DIR" },
    { code: "TELSUC", label: "c.TEL" },
    { code: "EMASUC", label: "c.EMA" },
    { code: "WHTSUC", label: "c.CEL" },
    { code: "WEBSUC", label: "c.WEB" },
    { code: "HO1SUC", label: "c.HO1" },
    { code: "HO21SUC", label: "c.HO2" },
    // { code: "HO3SUC", label: "c.HO3" },
    // { code: "MAPSUC", label: "c.MAP" },
    // { code: "WAZSUC", label: "c.WAZ" },
    // { code: "CODSUC", label: "", align: "center", type: "delete" },
  ],
  RUT: [
    { code: "CODRUT", label: "c.COD", type: "info" },
    { code: "NOMRUT", label: "c.NOM" },
    // { code: "CODRUT", label: "", align: "center", type: "delete" },
  ],
  ARE: [
    { code: "NOMARE", label: "c.NOM" },
    { code: "SUCARE", label: "c.SUC", align: "center", type: "branches" },
    { code: "COLARE", label: "c.COL", align: "center", type: "color" },
    // { code: "CODARE", label: "", align: "center", type: "delete" },
  ],
  HOR: [
    { code: "NOMHOR", label: "c.NOM" },
    { code: "HOR1HOR", label: "c.HOR1", align: "center", type: "time" },
    { code: "HOR2HOR", label: "c.HOR2", align: "center", type: "time" },
    // { code: "CODHOR", label: "", align: "center", type: "delete" },
  ],
  TAL: [
    { code: "NOMTAL", label: "c.NOM" },
    { code: "SUCTAL", label: "c.SUC", align: "center", type: "branches" },
    { code: "ACTTAL", label: "c.ACT", align: "center", type: "checkbox" },
    { code: "COLTAL", label: "c.COL", align: "center", type: "color" },
    { code: "AGETAL", label: "c.AGE", align: "center" },
    // { code: "CODTAL", label: "", align: "center", type: "delete" },
  ],
  TAR: [
    { code: "CODTAR", label: "c.COD", type: "info" },
    { code: "NOMTAR", label: "p.name" },
    { code: "MARTAR", label: "p.margin", align: "center" },
    { code: "ACTTAR", label: "p.active", align: "center", type: "checkbox" },
    { code: "VERTAR", label: "p.visible", align: "center", type: "checkbox" },
    // { code: "CODTAR", label: "", align: "center", type: "delete" },
  ],
  CTPA: [
    { code: "CODTPA", label: "p.code", type: "info" },
    { code: "NOMTPA", label: "p.name" },
    { code: "MENTPA", label: "p.message" },
    { code: "ACTTPA", label: "p.active", align: "center", type: "checkbox" },
    {
      code: "FCOTPA",
      label: "p.collectionDate",
      align: "center",
      type: "checkbox",
    },
    { code: "WEBTPA", label: "p.web", align: "center", type: "checkbox" },
    {
      code: "CUETPA",
      label: "p.account",
      align: "center",
      type: "bankAccounts",
    },
    {
      code: "CARTPA",
      label: "p.collectionFee",
      align: "center",
      type: "number",
    },
    {
      code: "PORTPA",
      label: "p.percentageOfPayment",
      align: "center",
      type: "number",
    },
    {
      code: "COMTPA",
      label: "p.percentageAssumed",
      align: "center",
      type: "number",
    },
    // { code: "CODTPA", label: "", align: "center", type: "delete" },
  ],
  VTPA: [
    { code: "CODTPA", label: "p.code", type: "info" },
    { code: "NOMTPA", label: "p.name" },
    { code: "MENTPA", label: "p.message" },
    { code: "ACTTPA", label: "p.active", align: "center", type: "checkbox" },
    {
      code: "FCOTPA",
      label: "p.collectionDate",
      align: "center",
      type: "checkbox",
    },
    { code: "WEBTPA", label: "p.web", align: "center", type: "checkbox" },
    {
      code: "CUETPA",
      label: "p.account",
      align: "center",
      type: "bankAccounts",
    },
    {
      code: "CARTPA",
      label: "p.collectionFee",
      align: "center",
      type: "number",
    },
    {
      code: "PORTPA",
      label: "p.percentageOfPayment",
      align: "center",
      type: "number",
    },
    {
      code: "COMTPA",
      label: "p.percentageAssumed",
      align: "center",
      type: "number",
    },
    // { code: "CODTPA", label: "", align: "center", type: "delete" },
  ],
  PAG: [
    { code: "NOMPAG", label: "c.NOM" },
    { code: "COLPAG", label: "c.COL", align: "center", type: "color" },
    { code: "ABRPAG", label: "c.ABR", align: "center", type: "statusType" },
    { code: "CIEPAG", label: "c.CIE", align: "center", type: "statusType" },
    { code: "SAVPAG", label: "c.SAV", align: "center", type: "statusType" },
    { code: "GARPAG", label: "c.GAR", align: "center", type: "checkbox" },
    { code: "ACTPAG", label: "c.ACT", align: "center", type: "checkbox" },
    { code: "DOCPAG", label: "c.DOC", align: "center", type: "checkbox" },
    { code: "LISPAG", label: "c.LIS", align: "center", type: "checkbox" },
    { code: "TALPAG", label: "c.TAL", align: "center", type: "checkbox" },
    // { code: "CODPAG", label: "", align: "center", type: "delete" },
  ],
  FOR: [
    { code: "NOMFOR", label: "c.NOM" },
    { code: "SUCFOR", label: "c.SUC", align: "center", type: "branches" },
    // { code: "CODFOR", label: "", align: "center", type: "delete" },
  ],
  ROL: [
    { code: "NOMROL", label: "c.NOM" },
    { code: "V", label: "p.analitics", align: "center", type: "checkbox" },
    { code: "A", label: "p.purchases", align: "center", type: "checkbox" },
    { code: "B", label: "p.sales", align: "center", type: "checkbox" },
    { code: "C", label: "p.services", align: "center", type: "checkbox" },
    { code: "D", label: "p.admin", align: "center", type: "checkbox" },
    { code: "E", label: "p.help", align: "center", type: "checkbox" },
    { code: "F", label: "p.items", align: "center", type: "checkbox" },
    { code: "G", label: "c.WEB", align: "center", type: "checkbox" },
    { code: "Z", label: "p.settings", align: "center", type: "checkbox" },
  ],
  SDA: [
    { code: "NOMSDA", label: "c.NOM" },
    { code: "FORSDA", label: "c.FOR", align: "center", type: "table" },
    { code: "SUFSDA", label: "c.SUF" },
    { code: "ACTSDA", label: "c.ACT", align: "center", type: "checkbox" },
    { code: "TABSDA", label: "c.TAB", align: "center" },
    { code: "TIPSDA", label: "c.TIP", align: "center", type: "issuesType" },
    { code: "GRUSDA", label: "c.GRU", align: "center", type: "table" },
    { code: "ORDSDA", label: "p.order", align: "center", type: "table" },
    { code: "TITSDA", label: "c.TIT", align: "center", type: "checkbox" },
    { code: "SELSDA", label: "c.SEL", align: "center" },
    { code: "GARSDA", label: "c.GAR", align: "center", type: "checkbox" },
    { code: "SECSDA", label: "c.SEC", align: "center", type: "checkbox" },
    { code: "SEC2SDA", label: "c.SEC2", align: "center", type: "checkbox" },
    { code: "SCHSDA", label: "c.SCH", align: "center", type: "checkbox" },
    { code: "RECSDA", label: "c.REC", align: "center", type: "checkbox" },
    { code: "INISDA", label: "c.INI", align: "center", type: "checkbox" },
    // { code: "CODSDA", label: "", align: "center", type: "delete" },
  ],
  DOC: [
    { code: "NOMDOC", label: "c.NOM" },
    { code: "SUCDOC", label: "c.SUC", align: "center", type: "branches2" },
    { code: "FOMDOC", label: "s.FOMDOC", align: "center", type: "checkbox" },
    { code: "ADSDOC", label: "c.ADS", align: "center", type: "checkbox" },
    { code: "POSDOC", label: "c.POS", align: "center", type: "checkbox" },
    // { code: "PRIDOC", label: "c.PRI", align: "center" },
    // { code: "PRI2DOC", label: "c.PRI2", align: "center" },
    { code: "ANCDOC", label: "p.width", align: "center" },
    { code: "ALTDOC", label: "p.height", align: "center" },
    { code: "CABDOC", label: "c.CAB", align: "center" },
    { code: "TANDOC", label: "p.tableWidth", align: "center" },
    { code: "TALDOC", label: "p.tableHeight", align: "center" },
    { code: "PADDOC", label: "s.PADDOC", align: "center" },
    { code: "SIZDOC", label: "c.SIZ", align: "center" },
    // { code: "FONDOC", label: "p.font", align: "center" },
    // { code: "ATADOC", label: "c.ATA", align: "center" },
    // { code: "TPADOC", label: "c.TPA", align: "center" },
    // { code: "ALIDOC", label: "p.align", align: "center" },
    // { code: "BOLDOC", label: "p.bold", align: "center", type: "checkbox" },
    // { code: "ITADOC", label: "p.italic", align: "center", type: "checkbox" },
    { code: "COLDOC", label: "c.COL", align: "center", type: "color" },
    // { code: "CFODOC", label: "c.CFO", align: "center", type: "color" },
    // { code: "COPDOC", label: "c.COP", align: "center", type: "checkbox" },
    // { code: "ANGDOC", label: "c.ANG", align: "center", type: "checkbox" },
    { code: "OBSDOC", label: "c.OBS", align: "center" },
  ],
};

export const webTabTitles: stdObject[] = [
  { code: "ACTTAB", label: "w.ACTTAB", align: "center", type: "checkbox" },
  { code: "CODTAB", label: "w.CODTAB", align: "center" },
  { code: "CLATAB", label: "w.CLATAB", align: "center" },
  { code: "LOCTAB", label: "w.LOCTAB", align: "center" },
  { code: "CL2TAB", label: "w.CL2TAB", align: "center" },
  { code: "DELTAB", label: "w.DELTAB", align: "center", type: "checkbox" },
  { code: "EXTTAB", label: "w.EXTTAB", align: "center" },
  { code: "FDETAB", label: "w.FDETAB", align: "center" },
  { code: "FOTTAB", label: "w.FOTTAB", align: "center" },
  { code: "WEBTAB", label: "w.WEBTAB", align: "center" },
];

export const headerRecords: stdObject[] = [
  {
    code: "date",
    label: "c.FEC",
    align: "left",
    type: "date",
    style: { width: 150 },
  },
  { code: "userName", label: "p.user", align: "left", style: { width: 200 } },
  { code: "typeName", label: "c.ARE", align: "center" },
  { code: "code", label: "c.COD", align: "center" },
  { code: "name", label: "c.NOM", align: "center", type: "recordName" },
  { code: "action", label: "c.ACN", align: "center", style: { width: 100 } },
];

export const headerRols: Array<stdObject> = [
  { code: "NOMROL", label: "c.NOM" },
  { code: "V", label: "p.analitics", align: "center", type: "checkbox" },
  { code: "A", label: "p.purchases", align: "center", type: "checkbox" },
  { code: "B", label: "p.sales", align: "center", type: "checkbox" },
  { code: "C", label: "p.services", align: "center", type: "checkbox" },
  { code: "D", label: "p.admin", align: "center", type: "checkbox" },
  { code: "E", label: "p.help", align: "center", type: "checkbox" },
  { code: "F", label: "p.items", align: "center", type: "checkbox" },
  { code: "G", label: "c.WEB", align: "center", type: "checkbox" },
  { code: "Z", label: "p.settings", align: "center", type: "checkbox" },
  // { code: "CODROL", label: "", align: "center", type: "delete" },
];

export const headerAccounting = [
  {
    code: "FECCAJ",
    label: "c.FEC",
    align: "left",
    type: "date",
    style: { width: 150 },
  },
  { code: "NAME", label: "c.DES", align: "left" },
  { code: "TIPDIN", label: "p.method", align: "center" },
  { code: "ENTCAJ", label: "p.inflow", align: "right", style: { width: 100 } },
  { code: "SALCAJ", label: "p.outflow", align: "right", style: { width: 100 } },
  { code: "BALCAJ", label: "p.balance", align: "right", style: { width: 100 } },
];

export const headerBatches = [
  { code: "ARTBA1", label: "c.COD", style: { width: 100 } },
  { code: "DESBA1", label: "c.DES", align: "left" },
  { code: "IDBA1", label: "c.BAT", align: "center" },
  { code: "SERBA1", label: "c.SUC", align: "center" },
  { code: "INBA1", label: "p.inflow", align: "right", style: { width: 100 } },
  {
    code: "OUTBA1",
    label: "p.outflow",
    align: "right",
    style: { width: 100 },
  },
  {
    code: "DISBA1",
    label: "p.available",
    align: "right",
    style: { width: 100 },
  },
];

export const headerInventory = [
  {
    code: "FECINV",
    label: "c.FEC",
    align: "left",
    type: "date",
    style: { width: 150 },
  },
  { code: "ARTINV", label: "c.ART" },
  { code: "CNOINV", label: "c.COL", align: "center", style: { width: 100 } },
  { code: "ALMINV", label: "c.ALM", align: "center", style: { width: 100 } },
  {
    code: "DISINV",
    label: "p.available",
    align: "center",
    style: { width: 100 },
  },
  {
    code: "ACTINV",
    label: "p.current",
    align: "center",
    style: { width: 100 },
  },
  { code: "NOMINV", label: "p.user", align: "center", style: { width: 100 } },
  { code: "OBSINV", label: "c.OBS", style: { width: 100 } },
];

export const headerMovements = [
  { code: "ARTMOV", label: "c.COD" },
  { code: "NOMMOV", label: "c.ART" },
  {
    code: "TRA1MOV",
    label: "p.transferIn",
    align: "center",
    style: { backgroundColor: colors.purchases },
  },
  {
    code: "ENTMOV",
    label: "c.ENT",
    align: "center",
    style: { backgroundColor: colors.purchases },
  },
  {
    code: "CFAMOV",
    label: "c.CFA",
    align: "center",
    style: { backgroundColor: colors.purchases },
  },
  {
    code: "DEVMOV",
    label: "c.DEV",
    align: "center",
    style: { backgroundColor: colors.purchases },
  },
  {
    code: "SALMOV",
    label: "c.SALP",
    align: "center",
    style: { backgroundColor: colors.purchases },
  },
  {
    code: "PREMOV",
    label: "c.PREP",
    align: "center",
    style: { backgroundColor: colors.sales },
  },
  {
    code: "FACMOV",
    label: "c.FAC",
    align: "center",
    style: { backgroundColor: colors.sales },
  },
  {
    code: "SEVMOV",
    label: "c.SEV",
    align: "center",
    style: { backgroundColor: colors.sales },
  },
  {
    code: "REGMOV",
    label: "c.REG",
    align: "center",
    style: { backgroundColor: colors.sales },
  },
  {
    code: "TRAMOV",
    label: "p.transferOut",
    align: "center",
    style: { backgroundColor: colors.sales },
  },
];

export const headerProfitability = [
  { code: "FECREN", label: "p.date" },
  { code: "NDOCREN", label: "c.DOC" },
  { code: "ARTREN", label: "c.COD" },
  { code: "NOMREN", label: "c.DES" },
  { code: "CANREN", label: "c.CAN", align: "center" },
  { code: "PCOREN", label: "p.cost", align: "right" },
  { code: "PREREN", label: "p.price", align: "right" },
  { code: "TOTREN", label: "c.TOT", align: "right" },
  { code: "TPCOREN", label: "p.totalCost", align: "right" },
  { code: "RESREN", label: "p.priceCost", align: "right" },
  { code: "COMREN", label: "p.commission", align: "right" },
  { code: "CHAREN", label: "p.surcharges", align: "right" },
  { code: "PORREN", label: "p.percentage", align: "right" },
  { code: "TRESREN", label: "p.profitability", align: "right" },
];

export const backupLang: stdObject = {};
